<template>
  <div >
      <ejs-grid ref='grid' :dataSource="data" :allowResizing='true'>
        <e-columns>
          <e-column field='alias' :headerText='$t("UE.ue_camera_name")' width='150' textAlign='Center'></e-column>
          <e-column field='ip4' :headerText='$t("UE.ue_ip")' width='150' textAlign='Center'></e-column>
          <e-column field='mac' :headerText='$t("UE.ue_mac")' width='150' textAlign='Center'></e-column>
        </e-columns>
      </ejs-grid>
  </div>
</template>
<script>
import { EventBus } from '../../plugins/eventBus';

export default {
  name: 'UeCameraTable',
  components: {

  },
  data() {
    return {
      data: {}
    };
  },
  methods: {
    queryData(qryParams) {
      const This = this;
      this.$axios.post('/lte/ems/subscriber/epcunms/requestCommon', qryParams).then((response) => {
        const res = response.data.resultVal;
        if (response.status === 200 && res !== null) {
          This.data = res.resultlist[0].cameraList;
          // EventBus.$emit('toast', { type: 'success', content: this.$t('Common.tips.success') });
        } else {
          EventBus.$emit('toast', { type: 'error', content: response.data.errorString });
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
